import React, { useState } from "react";
import Card from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";

const PaymentCard = ({ number, expiry, cvv, name, focus }) => {
  return (
    <div>
      <Card
        number={number}
        expiry={expiry}
        cvc={cvv}
        name={name}
        focused={focus}
        acceptedCards={["visa", "mastercard", "maestro", "american-express"]}
        placeholders={{ name: "TU NOMBRE" }}
        locale={{ valid: "VTO/HASTA" }}
      />
    </div>
  );
};

export default PaymentCard;
